import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Line from '../components/graphs/Line';
import Pie from '../components/graphs/Pie';
import { Row, Col } from 'react-bootstrap';
import MetricsFreeTextInsights from '../components/memberservices/MetricsFreeTextInsights';
import { fetchGenericHealthMetrics, addGenericMetricsVals, addMetricsWeight, fetch_vital_graphs, fetch_vital_graph } from '../components/services/Service';
import { LoaderLoader } from '../../utils/CommonLibrary';
import VitalsDisplayPanel from '../../RPMDashboard/components/VitalsDisplayPanel/VitalsDisplayPanel';
import BloodPressure from '../../RPMDashboard/components/Graphs/BloodPressure';
import SpO2 from '../../RPMDashboard/components/Graphs/SpO2';
import BodyTemperature from '../../RPMDashboard/components/Graphs/BodyTemperature';
import HeartRate from '../../RPMDashboard/components/Graphs/HeartRate';
import { VITAL_RANGES } from '../../../constants';
import { data } from 'jquery';
import BloodGlucose from '../../RPMDashboard/components/Graphs/BloodGlucose';
import Generic from '../../RPMDashboard/components/Graphs/Generic';



const HealthMetrics = (props) => {

    const [searchStr, setSearchStr] = useState("");
    const [loading, setLoading] = useState(false);
    const [updateError, setUpdateError] = useState("");
    const [updateMessage, setUpdateMessage] = useState("");
    const [vitalStatsInfo, setVitalStatsInfo] = useState({}); 
    const [vitalStatsRanges, setVitalStatsRanges] = useState({}); 
    const [vitals, setVitals]= useState([]); 
    const metricsObj = {
        userId: props.userId,
        metricsId: "",
        metricsName: "",
        metricsVal: "",
        metricsDate: null, 
        keyword: ""
    }
    const bmiMetricsObj = {
        userId: props.userId,
        metricsId: "",
        metricsName: "",
        metricsVal: "",
        metricsWeight: "",
        metricsHeight: "",
        metricsObservation: "",
        metricsDate: null
    }

    const bpMetricsObj = {
        userId: props.userId,
        metricsId: "",
        metricsName: "",
        metricsVal: "",
        metricsSystolic: "",
        metricsDiastolic: "",
        metricsObservation: "",
        metricsDate: null
    }

    const [selectedMetrics, setSelectedMetrics] = useState({});
    const [formData, setFormData] = useState(metricsObj);
    const [bmiFormData, setBMIFormData] = useState(bmiMetricsObj);
    const [bpFormData, setBPFormData] = useState(bpMetricsObj);
    const [genericHealthMetricsListAll, setGenericHealthMetricsListAll] = useState([]);
    const [genericHealthMetricsListFiltered, setGenericHealthMetricsListFiltered] = useState([]);
    const [weightUpdateMessage, setWeightUpdateMessage] = useState("");
    const [weightUpdateError, setWeightUpdateError] = useState("");

    /*const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [bmi, setBMI] = useState("");
    const [bmiObservation, setBMIObservation] = useState("");*/

    useEffect(() => {
        getGenericHealthMetrics();
    }, [props.userId])

    useEffect(() => {
        handleCompleteHealthMetricsGraph();
    }, [props.userId])

    useEffect(() => {
        if (bmiFormData.metricsWeight !== "" && bmiFormData.metricsHeight !== "") {
            const weight = bmiFormData.metricsWeight;
            const height = bmiFormData.metricsHeight;
            const heightInMeters = height / 100;
            let BMI = (weight / (heightInMeters * heightInMeters));

            BMI = parseFloat(BMI).toFixed(1)
            let observation = (BMI < 18.5) ? "Underweight" : (BMI >= 18.5 && BMI <= 24.9) ? "Healthy" : (BMI >= 25 && BMI <= 29.9) ? "Overweight" : "Obese";

            //setBMI(BMI);
            //setBMIObservation(observation);

            setBMIFormData((prevFormData) => ({
                ...prevFormData,
                "metricsVal": BMI,
                "metricsObservation": observation
            }));
        } else {
            //setBMI("");
            //setBMIObservation("");
            setBMIFormData((prevFormData) => ({
                ...prevFormData,
                "metricsVal": "",
                "metricsObservation": ""
            }));
        }
    }, [bmiFormData.metricsWeight, bmiFormData.metricsHeight])

    // Add new useEffect for blood pressure observation
    useEffect(() => {
        if (bpFormData.metricsSystolic !== "" && bpFormData.metricsDiastolic !== "") {
            const systolic = parseInt(bpFormData.metricsSystolic);
            const diastolic = parseInt(bpFormData.metricsDiastolic);
            let observation = "";
            
            // Blood pressure classification based on standard guidelines
            if (systolic < 90 || diastolic < 60) {
                observation = "Low Blood Pressure";
            } else if (systolic < 120 && diastolic < 80) {
                observation = "Normal";
            } else if ((systolic >= 120 && systolic <= 129) && diastolic < 80) {
                observation = "Elevated";
            } else if ((systolic >= 130 && systolic <= 139) || (diastolic >= 80 && diastolic <= 89)) {
                observation = "Stage 1 Hypertension";
            } else if (systolic >= 140 || diastolic >= 90) {
                observation = "Stage 2 Hypertension";
            } else if (systolic > 180 || diastolic > 120) {
                observation = "Hypertensive Crisis";
            }
            
            // Set the combined BP value and observation
            setBPFormData((prevFormData) => ({
                ...prevFormData,
                "metricsVal": `${systolic}/${diastolic}`,
                "metricsObservation": observation
            }));
        } else {
            setBPFormData((prevFormData) => ({
                ...prevFormData,
                "metricsVal": "",
                "metricsObservation": ""
            }));
        }
    }, [bpFormData.metricsSystolic, bpFormData.metricsDiastolic])

    //=====================================
    const [expandedRow, setExpandedRow] = useState(null);

    
    const toggleRowExpansion = (index) => {
        setUpdateError("");
        setUpdateMessage("");
        setExpandedRow((prevState) => (prevState === index ? null : index));
    };

    const handleIconClick = (e, item) => {
        e.stopPropagation(); // Prevent the row expansion from being triggered
        e.preventDefault();  // Prevent the default link navigation behavior
        setSelectedMetrics(item);
        
        handleShowHealthMetricsDetailsPopUpModal(); // Show the modal
    };

    const [showHealthMetricsDetailsPopUpModal, setShowHealthMetricsDetailsPopUpModal] = useState(false);
    const handleShowHealthMetricsDetailsPopUpModal = () => {
        setShowHealthMetricsDetailsPopUpModal(true);
    }

    const [showCompleteHealthMetricsGraph, setShowCompleteHealthMetricsGraph] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [ranges, setRanges] = useState([]); 
    const [vitalsData, setVitalsData] = useState({
        heartRate: {
            current: "",
            history: []
        },
        bodyTemperature: {
            current: "",
            history: []
        },
        spO2: {
            current: "",
            history: []
        },
        bmi: {
            current: ""
        },
        bloodGlucose: {
            current: "",
            type: "Fasting",
            history: []
        },
        bloodPressure: {
            current: "",
            history: []
        }
    });
    const handleCompleteHealthMetricsGraph = () => {
        setIsLoading(true);
        fetch_vital_graphs(props.userId)
            .then((response) => {
                if (response.data.code === 200 && response.data && response.data.data) {
                    setVitals(response?.data?.data?.metricsData); 
                    let getVitals = response?.data?.data?.metricsData; 

                    
                    Object.values(getVitals).forEach(async (vital) => {            
                        fetchSingleVitalGraph(vital.metricsId, vital.keyword);
                    });
                    
                    
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setIsLoading(false);
            });
    }
    //=========================================

    const searchTitle = async (searchTitle) => {
        if (searchTitle === "") {
            setGenericHealthMetricsListFiltered(genericHealthMetricsListAll);
        } else {
            const filteredDivs = genericHealthMetricsListAll.filter((div) =>
                div.metricsName.toLowerCase().includes(searchTitle.toLowerCase())
            );
            setGenericHealthMetricsListFiltered(filteredDivs);
        }
    }



    const getGenericHealthMetrics = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchGenericHealthMetrics(props.userId, ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setGenericHealthMetricsListFiltered(response.data.data.metrics);
                    setGenericHealthMetricsListAll(response.data.data.metrics);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleMetricsValChange = (name, newValue, inputType) => {
        setUpdateError("");
        setUpdateMessage("");

        if (inputType === "numeric" && !/^\d*\.?\d*$/.test(newValue)) {
            return;  // Prevent invalid value from updating the state
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: newValue, // Dynamically update the specific property
        }));

    };

    const handleBMIMetricsValChange = (name, newValue, inputType) => {
        setWeightUpdateError("");
        setWeightUpdateMessage("");

        if (inputType === "numeric" && !/^\d*\.?\d*$/.test(newValue)) {
            return;  // Prevent invalid value from updating the state
        }

        setBMIFormData((prevFormData) => ({
            ...prevFormData,
            [name]: newValue, // Dynamically update the specific property
        }));

    };

    const handleBPMetricsValChange = (name, newValue, inputType) => {
        setWeightUpdateError("");
        setWeightUpdateMessage("");

        if (inputType === "numeric" && !/^\d*\.?\d*$/.test(newValue)) {
            return;  // Prevent invalid value from updating the state
        }

        setBPFormData((prevFormData) => ({
            ...prevFormData,
            [name]: newValue, // Dynamically update the specific property
        }));
    };

    const handleUpdateForm = async () => {
        setUpdateError("");
        setUpdateMessage("");
        let valFound = 0;
        let errorFound = 0;

        const item = formData;

        // Check if metricsVal exists and is not an empty string
        const metricsValExists = (item.metricsVal?.trim() || "") !== "";
        const metricsDateExists = item.metricsDate && item.metricsDate !== "";

        if (metricsValExists) {
            valFound++;
        }

        // Validate metricsVal and metricsDate
        if (metricsValExists && !metricsDateExists) {
            setUpdateError("Please enter date for " + item.metricsName);
            errorFound++;
        } else if (!metricsValExists && metricsDateExists) {
            setUpdateError("Please enter value for " + item.metricsName);
            errorFound++;
        }else if(item.metricsVal?.trim() === "."){ 
            setUpdateError("Please enter value for " + item.metricsName);
            errorFound++;
        }

        if (valFound === 0 && errorFound == 0) {
            setUpdateError("Please enter the details first.");
            errorFound++;
        }

        if (errorFound === 0) {
            setLoading(true);
            let fd = structuredClone(formData);
            if (fd.metricsDate) {
                if ((fd.metricsDate) != "") {
                    fd.metricsDate = (moment(fd.metricsDate).isValid()) ? moment(fd.metricsDate).format('YYYY-MM-DD') : "";
                }
            }

            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            await addGenericMetricsVals({...fd, membershipNo: props.membershipNo}, ct)
                .then((response) => {
                    setLoading(false);
                    if (response.data.code === 200) {
                        setUpdateMessage(response.data.data.message);
                        setFormData((prevFormData) => ({
                            ...prevFormData,
                            metricsVal: "",
                            metricsDate: null
                        }));

                        fetchSingleVitalGraph(formData.metricsId, formData.keyword);

                        props.getMemberBasicInfo();
                        getGenericHealthMetrics();
                    } else {
                        setUpdateError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }
    /*const handleAddWeightHeight = (e) => {
        const { name, value } = e.target;
        if (name == "weight" || name == "height") {
            if (!/^\d*\.?\d*$/.test(value)) {
                return false;
            }
            if (name === "weight") {
                setWeight(value);
            }
            if (name == "height") {
                setHeight(value)
            }
        }
    }*/

    const handleAddWeightForm = async () => {
        setWeightUpdateError("");
        setWeightUpdateMessage("");

        if (bmiFormData.metricsWeight === "" || bmiFormData.metricsWeight.trim() === '.') {
            setWeightUpdateError("Please enter weight");
        } else if (bmiFormData.metricsHeight === "" ||  bmiFormData.metricsHeight.trim() === '.') {
            setWeightUpdateError("Please enter height");
        } else if (bmiFormData.metricsDate == null || bmiFormData.metricsDate == "") {
            setWeightUpdateError("Please enter date");
        }     
        else {

            let fd = structuredClone(bmiFormData);
            if (fd.metricsDate) {
                if ((fd.metricsDate) != "") {
                    fd.metricsDate = (moment(fd.metricsDate).isValid()) ? moment(fd.metricsDate).format('YYYY-MM-DD') : "";
                }
            }

            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            await addMetricsWeight(fd, ct)
                .then((response) => {
                    if (response.data.code === 200) {
                        /*setWeight("");
                        setHeight("");
                        setBMI("");
                        setBMIObservation("");*/
                        setBMIFormData((prevFormData) => ({
                            ...prevFormData,
                            metricsVal: "",
                            metricsWeight: "",
                            metricsHeight: "",
                            metricsObservation: "",
                            metricsDate: null
                        }));
                        fetchSingleVitalGraph(bmiFormData.metricsId, bmiFormData.keyword)
                        props.getMemberBasicInfo(props.userId);
                        setWeightUpdateMessage(response.data.data.message);
                        props.setRefreshVar(new Date().getTime());
                    } else {
                        setWeightUpdateError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }

    const handleAddBPForm = async () => {
        setWeightUpdateError("");
        setWeightUpdateMessage("");

        if (bpFormData.metricsSystolic.trim() === "" || bpFormData.metricsSystolic.trim() === '.') {
            setWeightUpdateError("Please enter systolic value");
        } else if (bpFormData.metricsDiastolic === "" || bpFormData.metricsDiastolic.trim() === ".") {
            setWeightUpdateError("Please enter diastolic value");
        } else if (bpFormData.metricsDate == null || bpFormData.metricsDate == "") {
            setWeightUpdateError("Please enter date");
        } else {
            let fd = structuredClone(bpFormData);
            if (fd.metricsDate) {
                if ((fd.metricsDate) != "") {
                    fd.metricsDate = (moment(fd.metricsDate).isValid()) ? moment(fd.metricsDate).format('YYYY-MM-DD') : "";
                }
            }

            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            await addGenericMetricsVals({...fd, membershipNo: props.membershipNo}, ct)
                .then((response) => {
                    if (response.data.code === 200) {
                        setBPFormData((prevFormData) => ({
                            ...prevFormData,
                            userId: props.userId,
                            metricsId: "",
                            metricsName: "",
                            metricsVal: "",
                            metricsSystolic: "",
                            metricsDiastolic: "",
                            metricsObservation: "",
                            metricsDate: null
                        }));
                        fetchSingleVitalGraph(bpFormData.metricsId, bpFormData.keyword); 
                        props.getMemberBasicInfo(props.userId);
                        setWeightUpdateMessage(response.data.data.message);
                        props.getMemberBasicInfo();
                        getGenericHealthMetrics(); 
                        props.setRefreshVar(new Date().getTime());
                    } else {
                        setWeightUpdateError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }

     // for fetching single vital graph
     function fetchSingleVitalGraph(vitalId, keyword){
        
        let newVitalsData = {}; 
        setIsLoading(true); 
        fetch_vital_graph({userId: props.userId, metricsId: vitalId}).then((response) => {
            if(response.data.code === 200){
                let graphData = response.data?.data?.data; 
                const title = response.data?.data?.metricsName; 
                const unit = response.data?.data?.unit; 
                let lastIndex = graphData.length - 1; 
                
                // Initialize the vital type in newVitalsData
                if(keyword == "bp"){ 
                    newVitalsData = {
                        current: graphData.length > 0 ? graphData[lastIndex].paramVal.toString(): 0,
                        currentObservation: graphData.length > 0 ? graphData[lastIndex]?.observation.observation || "": "",
                        history: graphData.map(item => {
                            const [systolic, diastolic] = item.paramVal.split('/');
                            return {
                                date: item.createdTime,
                                systolic: parseInt(systolic),
                                diastolic: parseInt(diastolic)
                            };
                        })
                    };

                    if(graphData.length > 0){ 
                        setVitalStatsInfo((prev) => { 
                            return { 
                                ...prev, 
                                [keyword]: { 
                                    title: title,
                                    unit: unit,
                                    current: graphData.length > 0 ? graphData[lastIndex].paramVal.toString(): 0,
                                    currentObservation: graphData.length > 0 ? graphData[lastIndex]?.observation.observation || "": "",
                                    history:graphData.map(item => {
                                        const [systolic, diastolic] = item.paramVal.split('/');
                                        return {
                                            date: item.createdTime,
                                            systolic: parseInt(systolic),
                                            diastolic: parseInt(diastolic)
                                        };
                                    })
                                }
                            }
                        });
                    }
                    

                }else { 
                    newVitalsData = {
                        current: graphData.length > 0 ? graphData[lastIndex].paramVal.toString(): 0,
                        currentObservation: graphData.length > 0 ? graphData[lastIndex]?.observation.observation || "": "",
                        history: graphData.map(item => ({
                            date: item.createdTime,
                            value: parseFloat(item.paramVal)
                        }))
                    };
                    
                    
                    if(graphData.length > 0){ 
                        
                        setVitalStatsInfo((prev) => { 
                            return { 
                                ...prev,    
                                [keyword]: { 
                                    title: title,
                                    unit: unit,
                                    current: graphData.length > 0 ? graphData[lastIndex].paramVal.toString(): 0,
                                    currentObservation: graphData.length > 0 ? graphData[lastIndex]?.observation.observation || "": "",
                                    history: graphData.map(item => ({
                                        date: item.createdTime,
                                        value: parseFloat(item.paramVal)
                                    }))
                                }
                            }
                        }); 
                    }
                }


                let vitalType = ""; 

                switch(keyword){ 
                    case "spo2": 
                        vitalType = "spO2"; 
                        break; 

                    case "pr": 
                        vitalType= "heartRate"; 
                        break; 
                    case "bt": 
                        vitalType="bodyTemperature"; 
                        break; 
                    case "bmi": 
                        vitalType= "bmi"; 
                        break; 
                    
                    case "bglf": 
                        vitalType="bloodGlucose"; 
                        break; 
                    
                    case "bgpp": 
                        vitalType= "bloodGlucoseRandom"; 
                        break; 
                    
                    case "bp": 
                        vitalType="bloodPressure"; 
                        break;
                    
                    default: 
                        vitalType="";
                        break; 
                }; 

                // Ensure that the vitalType is valid before updating
                if (vitalType) {
                    setVitalsData((prev) => { 
                        return { 
                            ...prev, 
                            [vitalType]: newVitalsData
                        }
                    })
                }

                // set the ranges as well 
                let jsondata = JSON.parse(response.data?.data?.ranges || '[]');
                let tempArr = []; 
                
                if(keyword == "bp") return; 

                jsondata?.forEach(element => {
                    let bandData = {};
                    bandData['value'] = element.max === "" ? VITAL_RANGES.bglf.max : element.max;
                    bandData['zIndex'] = 5; 

                    bandData['color'] = element.color;
                    bandData['width'] =  2; 
                    bandData['dashStyle'] =  'ShortDot';
                    
                    bandData['label'] = {
                        text: element.observation,
                        color: element.color,
                        align: 'left', 
                        y: 10,
                        verticalAlign: 'middle',
                        style: {
                            color: 'black',
                        }
                    }

                    tempArr.push(bandData);
                }); 

                // setting the ranges here
                setRanges((prev) => { 
                    return { 
                        ...prev, 
                        [vitalType]: tempArr  || []
                    }
                }); 


                setVitalStatsRanges((prev)  => { 
                    return { 
                        ...prev, 
                        [keyword]: tempArr || []
                    }
                })
            }
                
                
            
        }).catch((err) => { 
            // continue with error 
            console.log(err); 
        }).finally(() =>{ 
            setIsLoading(false); 
        }); 
    }

    const preventNonNumeric = (e) => {
        setTimeout(() => {
            e.target.value = e.target.value.replace(/[^0-9.]/g, '')
                .replace(/(\..*)\./g, '$1');
        }, 0);
    };

    return (
        <>
            <LoaderLoader isLoading={loading} />
            <div className='col-md-12 mb-3'>
                <div className='row d-flex justify-content-between'>
                    <div className='col-5'>
                        <input type="text" placeholder="Search Health Metrics by Title" className='form-control control-input-ui-addmember' onChange={(e) => searchTitle(e.target.value.trim())} />
                    </div>
                    <div className='col-auto'>
                        <button
                            className="btn btn-primary program-save-btn"
                            onClick={() => setShowCompleteHealthMetricsGraph(true)}
                        >
                            <i className="fa fa-bar-chart me-2" aria-hidden="true"></i>
                            View Health Metrics Graph
                        </button>
                    </div>
                </div>
            </div>

            <div className="" style={{ maxHeight: "60vh", overflowY: "scroll" }}>
                <div className="row">
                    {
                        genericHealthMetricsListFiltered.map((item, index) => {
                            {/* Health metrics Content 1 */ }
                            return <div className="col-md-12 mb-2" key={index}>
                                <Link
                                    className={`expandable-title-new d-flex tw-justify-between ${expandedRow === index ? 'active' : ''}`}
                                    onClick={(e) => {
                                        if (item.metricsName === "BMI") {
                                            setWeightUpdateError("");
                                            setWeightUpdateMessage("");
                                            setBMIFormData((prevFormData) => ({
                                                ...prevFormData,
                                                metricsId: item.metricsId,
                                                metricsName: item.metricsName,
                                                metricsVal: "",
                                                metricsWeight: "",
                                                metricsHeight: "",
                                                metricsObservation: "",
                                                metricsDate: null,
                                                keyword: item.keyword
                                            }));
                                        } else if (item.metricsName === "Blood Pressure") {
                                            setWeightUpdateError("");
                                            setWeightUpdateMessage("");
                                            setBPFormData((prevFormData) => ({
                                                ...prevFormData,
                                                metricsId: item.metricsId,
                                                metricsName: item.metricsName,
                                                metricsVal: "",
                                                metricsSystolic: "",
                                                metricsDiastolic: "",
                                                metricsObservation: "",
                                                metricsDate: null,
                                                keyword: item.keyword
                                            }));
                                        } else {
                                            setUpdateError("");
                                            setUpdateMessage("");
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                metricsId: item.metricsId,
                                                metricsName: item.metricsName,
                                                metricsVal: "",
                                                metricsDate: null,
                                                keyword: item.keyword
                                            }));
                                        }
                                        toggleRowExpansion(index);
                                    }}
                                >

                                    <div>
                                        {item.metricsName}
                                        {
                                            (vitalStatsInfo[item.keyword])  &&
                                            <i
                                                className="fa fa-bar-chart icons-hover"
                                                aria-hidden="true"
                                                style={{ marginLeft: "18px" }}
                                                onClick={(e) => handleIconClick(e, item)}
                                            />
                                        }
                                    </div>

                                    {expandedRow === index ? (

                                        <i className="bi bi-caret-up-fill" />
                                    ) : (
                                        <i className="bi bi-caret-down-fill" />
                                    )}
                                </Link>

                                {
                                    expandedRow === index && (
                                        (item.metricsName != "BMI" && item.metricsName != "Blood Pressure") ?
                                            <div className="row">
                                                <div className="col-md-12 mt-3 px-4">
                                                    <div className='row'>
                                                        <div className='col-md-6 mb-3'>
                                                            <label className="form-label">
                                                                Value
                                                                {
                                                                    item.unit !== "" && " (" + item.unit + ")"
                                                                }
                                                            </label>
                                                            {
                                                                item.inputType == "numeric" && item.metricsName !== "BMI" &&
                                                                <input type='text' name={`metricsVal_${index}`} value={formData.metricsVal} className='form-control control-input-ui' placeholder={`Enter Value`} onChange={(e) => handleMetricsValChange("metricsVal", e.target.value, "numeric")} onInput={preventNonNumeric} />
                                                            }
                                                            {
                                                                item.inputType == "freetext" &&
                                                                <textarea name={`metricsVal_${index}`} value={formData.metricsVal} className='form-control control-input-ui' onChange={(e) => handleMetricsValChange("metricsVal", e.target.value, "freetext")}></textarea>
                                                            }
                                                            {
                                                                item.inputType == "select" &&
                                                                <select name={`metricsVal_${index}`} value={formData.metricsVal} className='form-control control-input-ui' onChange={(e) => handleMetricsValChange("metricsVal", e.target.value, "select")}>
                                                                    <option value="">Select</option>
                                                                    {
                                                                        item.possibleValues.map((pval, pindex) => {
                                                                            return <option key={pindex} value={pval.value}>{pval.label}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 mb-3'>
                                                            <label className="form-label">Date</label>
                                                            <DatePicker
                                                                dateFormat="dd-MM-yyyy"
                                                                className='form-control control-input-ui'
                                                                selected={formData.metricsDate || null} // Ensure null when no date is selected
                                                                placeholderText="Enter Date" // Use placeholderText for DatePicker
                                                                maxDate={new Date()}
                                                                onChange={(date) => handleMetricsValChange("metricsDate", date, "date")}
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                onPaste={(e) => e.preventDefault()}
                                                            />
                                                        </div>
                                                        <div className='col-md-12 mb-3 text-center'>
                                                            <div className={`${updateError != "" ? "errorDiv" : "hide"} `}>{updateError}</div>
                                                            <div className={`${updateMessage != "" ? "messageDiv" : "hide"}`}>{updateMessage}</div>
                                                            <button type="submit" class="btn btn-primary btn-primary program-save-btn me-2" onClick={handleUpdateForm}>Save</button>
                                                            <button type="reset" class="btn clear-btn" onClick={(e) => {
                                                                setFormData((prevFormData) => ({
                                                                    ...prevFormData,
                                                                    metricsId: item.metricsId,
                                                                    metricsName: item.metricsName,
                                                                    metricsVal: "",
                                                                    metricsDate: null, 
                                                                    keyword: ""
                                                                }));
                                                            }}>Clear</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {
                                                    item.metricsName === "BMI" ?
                                                        <div className='row'>
                                                            <div className='col-4 mb-3'>
                                                                <label className="form-label">Weight (in kgs):</label>
                                                                <input type="text" value={bmiFormData.metricsWeight} name="metricsWeight" className='form-control control-input-ui' onChange={(e) => handleBMIMetricsValChange("metricsWeight", e.target.value, "numeric")} />
                                                            </div>
                                                            <div className='col-4 mb-3'>
                                                                <label className="form-label">Height (in cms):</label>
                                                                <input type="text" value={bmiFormData.metricsHeight} name="metricsHeight" className='form-control control-input-ui' onChange={(e) => handleBMIMetricsValChange("metricsHeight", e.target.value, "numeric")} />
                                                            </div>
                                                            <div className='col-4 mb-3'>
                                                                <label className="form-label">Date</label>
                                                                <DatePicker
                                                                    dateFormat="dd-MM-yyyy"
                                                                    className='form-control control-input-ui'
                                                                    selected={bmiFormData.metricsDate || null} // Ensure null when no date is selected
                                                                    placeholderText="Enter Date" // Use placeholderText for DatePicker
                                                                    maxDate={new Date()}
                                                                    onChange={(date) => handleBMIMetricsValChange("metricsDate", date, "date")}
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                />
                                                            </div>
                                                            <div className='col-12'>
                                                                <span className={`${bmiFormData.metricsObservation !== "" ? "" : "hide"}`}>BMI: {bmiFormData.metricsVal}  ({bmiFormData.metricsObservation})</span>
                                                            </div>
                                                            <div className='col-12 text-center'>
                                                                <div className={`${weightUpdateError != "" ? "errorDiv" : "hide"}`}>{weightUpdateError}</div>
                                                                <div className={`${weightUpdateMessage != "" ? "messageDiv" : "hide"}`}>{weightUpdateMessage}</div>

                                                                <button className="btn btn-primary btn-primary program-save-btn me-2" onClick={handleAddWeightForm}>Save</button>
                                                                <button type="reset" class="btn clear-btn" onClick={(e) => {
                                                                    setBMIFormData((prevFormData) => ({
                                                                        ...prevFormData,
                                                                        metricsId: "",
                                                                        metricsName: "",
                                                                        metricsVal: "",
                                                                        metricsWeight: "",
                                                                        metricsHeight: "",
                                                                        metricsObservation: "",
                                                                        metricsDate: null
                                                                    }));
                                                                    /*setWeight("");
                                                                    setHeight("");
                                                                    setBMI("");
                                                                    setBMIObservation("");*/
                                                                    setWeightUpdateError("");
                                                                    setWeightUpdateMessage("");
                                                                }}>Clear</button>
                                                            </div>
                                                        </div> :
                                                        <div className='row'>
                                                        <div className='col-4 mb-3'>
                                                            <label className="form-label">Systolic (in mmHg):</label>
                                                            <input type="text" value={bpFormData.metricsSystolic} name="metricsSystolic" className='form-control control-input-ui' onChange={(e) => handleBPMetricsValChange("metricsSystolic", e.target.value, "numeric")} />
                                                        </div>
                                                        <div className='col-4 mb-3'>
                                                            <label className="form-label">Diastolic (in mmHg):</label>
                                                            <input type="text" value={bpFormData.metricsDiastolic} name="metricsDiastolic" className='form-control control-input-ui' onChange={(e) => handleBPMetricsValChange("metricsDiastolic", e.target.value, "numeric")} />
                                                        </div>
                                                        <div className='col-4 mb-3'>
                                                            <label className="form-label">Date</label>
                                                            <DatePicker
                                                                dateFormat="dd-MM-yyyy"
                                                                className='form-control control-input-ui'
                                                                selected={bpFormData.metricsDate || null} // Ensure null when no date is selected
                                                                placeholderText="Enter Date" // Use placeholderText for DatePicker
                                                                maxDate={new Date()}
                                                                onChange={(date) => handleBPMetricsValChange("metricsDate", date, "date")}
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                onPaste={(e) => e.preventDefault()}
                                                            />
                                                        </div>
                                                        <div className='col-12'>
                                                            <span className={`${bpFormData.metricsObservation !== "" ? "" : "hide"}`}>Blood Pressure: {bpFormData.metricsSystolic} / {bpFormData.metricsDiastolic}  ({bpFormData.metricsObservation})</span>
                                                        </div>
                                                        <div className='col-12 text-center'>
                                                            <div className={`${weightUpdateError != "" ? "errorDiv" : "hide"}`}>{weightUpdateError}</div>
                                                            <div className={`${weightUpdateMessage != "" ? "messageDiv" : "hide"}`}>{weightUpdateMessage}</div>

                                                            <button className="btn btn-primary btn-primary program-save-btn me-2" onClick={handleAddBPForm}>Save</button>
                                                            <button type="reset" class="btn clear-btn" onClick={(e) => {
                                                                setBPFormData((prevFormData) => ({
                                                                    ...prevFormData,
                                                                    metricsId: "",
                                                                    metricsName: "",
                                                                    metricsVal: "",
                                                                    metricsSystolic: "",
                                                                    metricsDiastolic: "",
                                                                    metricsObservation: "",
                                                                    metricsDate: null
                                                                }));
                                                                setWeightUpdateError("");
                                                                setWeightUpdateMessage("");
                                                            }}>Clear</button>
                                                        </div>
                                                    </div> 
                                                }
                                            </>
                                    )
                                }
                            </div>
                        })
                    }
                </div>
            </div >

            <Modal id="HealthMetricsDetailsPopUp" show={showHealthMetricsDetailsPopUpModal} onHide={() => setShowHealthMetricsDetailsPopUpModal(false)} size="lg" backdrop="static" keyboard={false} fullscreen={false}>
                <Modal.Header closeButton>
                    <h1 className='modal-title'>{selectedMetrics.metricsName}</h1>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg="12" className=' mb-4'>
                            <div className='dashboard-graph-box card-task p-2 ps-1'>
                                {
                                    new Array("bp", "spo2", "bt", "pr", 'bgpp', 'bglf', 'hba1c', 'bmi').includes(selectedMetrics.keyword) ?
                                    <div>

                                        { 
                                            selectedMetrics.keyword === "bp"?
                                            (
                                                <BloodPressure data={vitalStatsInfo[selectedMetrics.keyword]} />
                                            ): 
                                            (
                                                  <Generic data={vitalStatsInfo[selectedMetrics.keyword]} ranges={vitalStatsRanges[selectedMetrics.keyword]} />
                                            )
                                        }   
                                        {/* {
                                            selectedMetrics.keyword == "bp" &&
                                            <BloodPressure data={vitalsData.bloodPressure} />
                                        }

                                        {selectedMetrics.keyword == "spo2" &&
                                            <SpO2 data={vitalsData.spO2} />
                                        }

                                        {selectedMetrics.keyword == "bt" &&
                                            <BodyTemperature data={vitalsData.bodyTemperature} />
                                        }

                                        {selectedMetrics.keyword == "pr" &&
                                            <HeartRate data={vitalsData.heartRate} />
                                        }

                                        {
                                             (selectedMetrics.keyword === "bgpp" || selectedMetrics.keyword === "bglf") && 
                                             <BloodGlucose bloodGlucose={vitalsData.bloodGlucose} bloodGlucoseRandom={vitalsData.bloodGlucoseRandom}
                                                bloodGlucoseRanges={ranges?.bloodGlucose || []}
                                                bloodGlucoseRandomRanges={ranges?.bloodGlucoseRandom || []}
                                                glucoseType={selectedMetrics.keyword === "bglf"? 'fasting': 'pp/random'}
                                            />
                                        } */}
                                        
                                    </div> : 
                                    
                                    <div>
                                        {
                                            selectedMetrics.inputType == "numeric" &&
                                            <Line lineGraphTitle={selectedMetrics.metricsName} lineGraphType="metrics_insights_numeric_data" userId={props.userId} refreshVar={props.refreshVar} metricsId={selectedMetrics.metricsId} />
                                        }
                                        {
                                            selectedMetrics.inputType == "select" &&
                                            <Pie pieGraphTitle={selectedMetrics.metricsName} pieGraphType="metrics_insights_select_data" userId={props.userId} refreshVar={props.refreshVar} metricsId={selectedMetrics.metricsId} />
                                        }
                                        {
                                            selectedMetrics.inputType == "freetext" &&
                                            <MetricsFreeTextInsights userId={props.userId} metricsId={selectedMetrics.metricsId} metricsName={selectedMetrics.metricsName} />
                                        }
                                    </div>
                                }
                                
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal id="HealthMetricsDetailsPopUp" show={showCompleteHealthMetricsGraph} className='tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50' onHide={() => setShowCompleteHealthMetricsGraph(false)} size="xl" backdrop={false} keyboard={false} fullscreen={false}>
                <Modal.Header closeButton>
                    <h1 className='modal-title'>Complete Health Metrics Graph</h1>
                </Modal.Header>
                <Modal.Body>
                    <VitalsDisplayPanel isLoading={isLoading} vitalsDataProp={vitalsData} ranges={ranges} vitals={vitals} fetchSingleVitalGraph={fetchSingleVitalGraph} vitalStatsInfo={vitalStatsInfo} vitalStatsRanges={vitalStatsRanges} />
                </Modal.Body>
            </Modal>
        </>

    );
};

export default HealthMetrics;